import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { EappBeneficiaryGateway } from './EAppEnrollment-gateway'
import { EnrollmentFieldBeneficiary, EnrollmentFieldCodesBeneficiary } from '../models/enrollment-field-beneficiary'
import { EappUpdateStatusBeneficiary } from '../models/eapp-beneficiary-status-model'
import { BeneficiaryElectionPeriods } from '../models/beneficiary-election-periods'
import { EnrollmentElectionType } from '../models/enrollment-election-type'
import { UserProfile } from '../models/user-profile'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { PlanList } from '../models/plan-list'
import { GetEnrollmentDataModel } from '../models/getEnrollmentDataModel'
import { SubmitEnrollmentDataResponse } from '../models/submit-enrollment-data-response'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { VerifyBeneficiary } from '../models/verify-beneficiary'
import { GenderPref } from '../../enrollment/models/gender-pref'
import { RelationshipToEnrollee } from '../models/relationshipToEnrollee'

@Injectable()
export class NetworkEppBeneficiaryGateway extends EappBeneficiaryGateway {
    private _enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    public _backClicked: boolean
    private _enrollmentDataModel: GetEnrollmentDataModel = new GetEnrollmentDataModel()

    constructor(private http: HttpClient) {
        super()
    }

    getEnrollmentAppDetails(guid: string): Observable<EnrollmentFieldBeneficiary[]> {
        return this.http.get<EnrollmentFieldBeneficiary[]>('../api/enrollment/GetEnrollmentApplicationNew/' + guid)
    }

    getEappDetails(uniqueLink: string): Observable<EappUpdateStatusBeneficiary[]> {
        return this.http.get<EappUpdateStatusBeneficiary[]>('../api/enrollment/geteappstatus/' + uniqueLink)
    }

    updateEAppStatus(eappUpdateStatus: EappUpdateStatusBeneficiary): Observable<EappUpdateStatusBeneficiary> {
        return this.http.post<EappUpdateStatusBeneficiary>('../api/enrollment/UpdateElectronicEnrollmentStatusNew', JSON.stringify(eappUpdateStatus))
    }

    verifyBeneficiary(beneficiaryInfo: VerifyBeneficiary): Observable<EappUpdateStatusBeneficiary> {
        return this.http.post<EappUpdateStatusBeneficiary>('../api/enrollment/eappverify', JSON.stringify(beneficiaryInfo))
    }

    findUserProfileByProfileID(profileID: number): Observable<UserProfile> {
        let getURL = '../api/userProfileNew/' + profileID
        return this.http.get<UserProfile>(getURL)
    }

    SendAgentEmail(mailTo: string, Reason: string, agentName: string, agentID: number, beneName: string): Observable<any> {
        return this.http.get<string>('../api/SendEmailToAgent/' + mailTo + '/' + Reason + '/' + agentName + ' / ' + agentID + ' / ' + beneName)
    }

    notifyeAppAgent(agentId: number, bFName: string, bLName: string, reason: string): Observable<any> {
        return this.http.get<string>('../api/notifyeAppAgent/' + agentId + '/' + bFName + '/' + bLName + '/' + reason)
    }

    getElectionPeriods(orgId: number, planYear: string): Observable<BeneficiaryElectionPeriods[]> {
        return this.http.get<BeneficiaryElectionPeriods[]>('../api/enrollment/GetBeneficiaryElectionPeriodsNew/' + orgId + '/' + planYear)
    }

    getEnrollmentElectionTypes(orgID: string, planYear: string): Observable<EnrollmentElectionType[]> {
        return this.http.get<EnrollmentElectionType[]>(`../api/EnrollmentElectionTypesByOrgIDNew/${orgID}/${planYear}`)
    }

    setEnrollmentViewModel(value: EnrollmentViewModel) {
        if (value && !this._backClicked) {
            this._enrollmentViewModel = value
        }
        this._backClicked = false
    }

    getEnrollmentViewModel(): EnrollmentViewModel {
        return this._enrollmentViewModel
    }

    getPlanList(orgId: number, planyear: string): Observable<PlanList[]> {
        let getURL = '../api/enrollment/GetPlanListNew/' + orgId + '/' + planyear
        return this.http.get<PlanList[]>(getURL)
    }

    SubmitEnrollmentData(enrollModel: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/EAppSubmitEnrollmentDataNew',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    UpdateEnrollmentData(): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/UpdateEnrollmentData',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }

    SendEmailUser(): Observable<any> {
        return this.http.post<EnrollmentViewModel>(
            '../api/enrollment/SendEmailUser',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }
    SubmitElectronicEnrollmentData(): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/SubmitElectronicEnrollment',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }
    UpdateElectronicEnrollmentData(): Observable<SubmitEnrollmentDataResponse> {
        return this.http.post<SubmitEnrollmentDataResponse>(
            '../api/enrollment/UpdateElectronicEnrollmentDataNew',
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }
    SendEappEmailOnConfirmation(planName: string): Observable<any> {
        return this.http.post<EnrollmentViewModel>(
            '../api/enrollment/SendEappEmailOnConfirmationNew/' + planName,
            JSON.stringify(this._enrollmentDataModel.getEnrollmentData(this.getEnrollmentViewModel()))
        )
    }
    getLogoPath(orgId: number, planyear: string): Observable<string> | undefined {
        if (orgId !== undefined && planyear !== undefined) {
            return this.http.get<string>('../api/enrollment/GetLogoPathNew/' + orgId + '/' + planyear)
        }
    }

    GetAllStatesForBeneficiary(InsuranceCoID: number): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetAllStatesForBeneficiaryNew/' + InsuranceCoID
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    GetGenderPreferenceListForBeneficiary(genderPref: string): Observable<GenderPref[]> {
        return this.http.get<GenderPref[]>(`../api/enrollment/GetGenderPreferenceListForBeneficiary/${genderPref}`)
    }

    //getRelationshipToEnrolleeData(): Observable<RelationshipToEnrollee[]> {
    //    return this.http.get<RelationshipToEnrollee[]>(`../api/enrollment/getRelationshipToEnrolleeData`)
    //}
    getRelationshipToEnrolleeDataForBeneficiary(): Observable<RelationshipToEnrollee[]> {
        return this.http.get<RelationshipToEnrollee[]>(`../api/getRelationshipToEnrolleeDataForBeneficiary`)
    }
}
